import React, { useEffect, useCallback, useState} from 'react';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import {connect} from 'react-redux';

const LP = 'LP';
const HP = 'HP';

const FilterSection = (props) => { 
    let [filterType, setFilterType] = useState(LP);
    useEffect(() => {
        if (props.selectedParameter) {
            if (props.selectedParameter.name.includes("hi-pass")) {
                setFilterType(HP);
            } else {
                setFilterType(LP);
            }
        }
        }, [props.selectedParameter, props.instrument, setFilterType]);
    return (
        <div className="instrument-subsection filter-section">
          <div className="clear-fix"/>
          <div className="filter-types">
            <Option name="Low-pass" option={LP} selectedType={filterType} setType={setFilterType}/>
            <Option name="Hi-pass" option={HP} selectedType={filterType} setType={setFilterType}/>
          </div>
          <EffectParameterSlider
            automation={props.automation}
            name={'Cutoff'}
            sequencerEngine={props.sequencerEngine}
            lfoEnabled={true}
            parameter={filterType === LP ?
                       props.instrument.filterCutoffParameter :
                       props.instrument.hpFilterCutoffParameter
                      }
            onParameterChanged={() => []}
            isParameter={true}
            root={1.5}
            min={0}
            max={10000}
            step={1}
          />
          <EffectParameterSlider
            automation={props.automation}
            name={'Resonance'}
            sequencerEngine={props.sequencerEngine}
            parameter={filterType === LP ?
                       props.instrument.filterQParameter :
                       props.instrument.hpFilterQParameter
                      }
            lfoEnabled={true}
            onParameterChanged={() => []}
            isParameter={true}
            min={0}
            max={20}
            step={1}
          />
        </div>
    );
}

const Option = ({selectedType, setType, option, name}) => {
    let className = selectedType === option ?
        "selected option" : "option";
    return (
        <div
          onClick={()=>setType(option)}
          className={className}>
          {name}
        </div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        selectedParameter: state.effects.accumulatorParameterSelected
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterSection);
